import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Rodapé do formulário (T35): as ações de um cadastro ficam depois dos campos, nunca no cabeçalho
 * da página. À direita a ação primária em ink e, antes dela, a secundária em contorno (Cancelar,
 * Voltar); à esquerda o estado ("salvo há 2 minutos") ou uma nota. Abaixo de 900px as ações viram
 * coluna, a primária por cima, cada uma na largura toda. A ação destrutiva não entra aqui: fica
 * num cartão à parte, separada do salvar.
 */
export interface FormFooterProps extends HTMLAttributes<HTMLDivElement> {
  /** A ação primária: salvar, cadastrar, criar. */
  primary: ReactNode
  /** A secundária, em contorno: cancelar, voltar. */
  secondary?: ReactNode
  /** O estado à esquerda: "salvo há 2 minutos", "alterações não salvas", uma nota. */
  status?: ReactNode
  /** Nome acessível do grupo de ações. */
  label?: string
}

export function FormFooter({
  primary,
  secondary,
  status,
  label = 'Ações do formulário',
  className,
  ...props
}: FormFooterProps) {
  return (
    <div
      data-slot="form-footer"
      role="group"
      aria-label={label}
      className={cn(
        'border-hairline max-desk:flex-col max-desk:items-stretch flex flex-wrap items-center justify-between gap-4 border-t pt-5',
        className,
      )}
      {...props}
    >
      <div className="font-body text-eyebrow text-label min-w-0 font-light tracking-normal">
        {status}
      </div>
      <div
        data-slot="form-footer-actions"
        className="max-desk:flex-col-reverse max-desk:items-stretch max-desk:gap-3 max-desk:*:w-full flex shrink-0 items-center gap-[10px]"
      >
        {secondary}
        {primary}
      </div>
    </div>
  )
}
